import type { FC, ReactNode } from 'react'

import { THEME_TITLES } from '@/constants/leesritme'

export const ThemeMarquee: FC = (): ReactNode => {
    return (
        <section id='themas' aria-labelledby='themas-titel' className='relative bg-ink text-paper'>
            <div className='mx-auto flex max-w-7xl flex-col gap-4 px-5 py-6 sm:px-8 lg:flex-row lg:items-center lg:gap-8'>
                <h2 id='themas-titel' className='shrink-0 text-sm leading-snug font-bold text-sun lg:max-w-[13rem]'>
                    238 themaweken, van Huisdieren tot De race naar de maan
                </h2>

                <div className='marquee marquee-mask min-w-0 flex-1 overflow-hidden'>
                    <div className='marquee-track flex w-max'>
                        <ul className='flex shrink-0'>
                            {THEME_TITLES.map(title => (
                                <li key={title} className='flex items-center gap-8 pr-8 font-heading text-xl whitespace-nowrap italic'>
                                    {title}
                                    <span aria-hidden='true' className='size-1.5 rounded-full bg-coral' />
                                </li>
                            ))}
                        </ul>

                        <ul aria-hidden='true' className='flex shrink-0'>
                            {THEME_TITLES.map(title => (
                                <li key={title} className='flex items-center gap-8 pr-8 font-heading text-xl whitespace-nowrap italic'>
                                    {title}
                                    <span className='size-1.5 rounded-full bg-coral' />
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    )
}
